import React from 'react';
import PropTypes from 'prop-types';
import { getLayoutType, TEMPLATE_LAYOUT } from 'editor-utils/template';
import { Panel, Typography } from '../../components/base';
import useEditorItemContext from '../../context/editorItemContext';

const TooltipPanel = props => {
  const { platform, template, config } = useEditorItemContext();

  const paragraphs = [];

  //
  // 1. MESSAGES BY TYPES
  // 2. OTHER CONDITIONS
  //
  if (props.type === 'book-preview') {
    if (config.source === 'ancestry' || config.source === 'familysearch') {
      paragraphs.push({
        key: 'book-preview-1',
        children: (
          <>
            You are in your Book Preview. Click on a page to edit photos and text on that page. The
            Table of Contents is dynamic and will automatically update as you build the book. It will
            reset to the default font settings each time you add or remove a page. If you would like
            to edit the font in your Table of Contents, please wait until the rest of the book is
            finalized.
          </>
        ),
      });
    } else if (platform === "mycanvas") {
      paragraphs.push({
        key: 'book-preview-1',
        children: (
          <>
            You are in your book preview. First, name and save your project at the top-right of this screen.
            Then, click on a page to begin adding photos and text. Your edits will be saved automatically.
            This project draft is stored on your account, so you can work at your own pace.
            Resume your draft at <a href="/user/creations">My Projects</a>.
            For help, visit our <a href="https://intercom.help/mycanvas/en/collections/10780837-mycanvas-premium-hardcover-book" target="_blank" rel="noopener noreferrer">Help Center</a>.
          </>
        ),
      });
    } else if (platform === "parabo") {
      paragraphs.push({
        key: 'book-preview-1',
        children: (
          <>
            You are in your book preview. First, name and save your project at the top-right of this screen.
            Then, click on a page to begin adding photos and text. Your edits will be saved automatically.
            This project draft is stored on your account, so you can work at your own pace.
            Resume your draft at My < a href="/user/creations">Account → My Creations</a>.
            For help, visit our <a href="https://knowledge-base--parabo.groovehq.com/help/premium-hardcover-book" target="_blank" rel="noopener noreferrer">Help Center</a>.
          </>
        ),
      });
    }
  } else if (props.type === 'book-page') {
    paragraphs.push({
      key: 'book-page-1',
      children: (
        <>
          <strong>To edit, replace or remove a photo:</strong>
          <br />
          Click on the photo on this screen.
        </>
      ),
    });

    paragraphs.push({
      key: 'book-page-2',
      children: (
        <>
          When done editing, click on the <strong>Done</strong> button on the top of this page to
          return to your Book Preview.
        </>
      ),
    });
  } else {
    paragraphs.push({
      key: 'tooltip-1',
      children: (
        <>
          You are previewing your print. To edit, zoom, crop, or replace a photo, just tap the
          photo.
        </>
      ),
    });

    if (config.source !== 'ancestry' && getLayoutType(template) === TEMPLATE_LAYOUT.AUTOMATIC) {
      paragraphs.push({
        key: 'template-automatic-1',
        children: template.id.startsWith('framedprint') ? (
          <>Click the three dots in the upper-right corner of the frame to change orientation.</>
        ) : (
          <>Click the three dots on a page to change page layout.</>
        ),
      });
    }
  }

  if (paragraphs.length > 0) {
    return (
      <Panel borderColor="green">
        <Typography.Heading size={2}>{props.title}</Typography.Heading>
        {paragraphs.map(paragraph => (
          <Typography.Paragraph key={paragraph.key} mt={3}>
            {paragraph.children}
          </Typography.Paragraph>
        ))}
      </Panel>
    );
  }

  return null;
};

TooltipPanel.propTypes = {
  title: PropTypes.string,
  type: PropTypes.string,
};

TooltipPanel.defaultProps = {
  title: 'Help',
  type: 'default',
};

export default TooltipPanel;
